export default {
  head: {
    title: 'Operator Lookup operations billing',
    action: {
      create: {
        tooltip: 'Create new Operator Lookup report'
      },
      search: {
        tooltip: 'Search single operation by Operation Id'
      }
    }
  },
  footer: {
    label: 'Total cost',
    tooltip: 'Value from entire period including selected filters'
  },
  dialog: {
    search: {
      title: 'Search Operator Lookup billing operation'
    }
  }
};
